import React, {useState} from 'react';
import { Button,
        TextField,
        Dialog,
        DialogActions,
        DialogContent,
        DialogTitle, 
        FormControlLabel,
        Checkbox
    }from '@mui/material';


const AddNewCategoryDialog = ({open, onclose}) => {
  const [checkedAdd, setCheckedAdd] = useState(false);

  // Reset checkbox when dialog closes
  React.useEffect(() => {
    if (!open) setCheckedAdd(false);
  }, [open]);


  return (
      <Dialog
        open={open}
        onClose={onclose}
       
      >
        <DialogTitle>Add New Category</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            id="name"
            name="add category"
            label="Add Category"
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <FormControlLabel
                  required 
                  control={
                    <Checkbox
                      checked={checkedAdd}
                      onChange={e => setCheckedAdd(e.target.checked)}
                    />
                  }
                  label="confirm the category name is correct"
                />
        <DialogActions>
          <Button onClick={onclose}>Cancel</Button>
          <Button 
          type="submit"
          disabled={!checkedAdd}
          style={{ filter: !checkedAdd ? 0.5 : 1 }}
          >
            Add
          </Button>
        </DialogActions>
      </Dialog>
  );
};
export default AddNewCategoryDialog;
